module.exports = __webpack_public_path__ + "img/avatar-3.a8e2a7d5.png";